module.exports = __webpack_public_path__ + "static/wysowianka-63e97c575048ba773d5ce58389b82324.png";